import {useEffect, useState} from "react"

export default function DocumentTitle(
    {
        title,
        appending = true
    }: {
        title: string | undefined,
        appending?: boolean
    }
) {
    const [docTitle, setDocTitle] = useState<string>("PCK AS")

    useEffect(() => {
        if (!title)
            return

        setDocTitle(() => `${title}${appending ? ' - PCK AS' : ''}`)
    }, [appending, title])

    useEffect(() => {
        document.title = docTitle
    }, [docTitle])

    return <></>
}
